import BaseAPI from "../baseService";

class WalletServiceProvider extends BaseAPI {
	constructor() {
		super("financials");
	}

	/**
	 * charge wallet
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public fundWallet(amount: string | number): Promise<HttpService.BaseResponse> {
		// return this.dynamicMakeResource("financials", "v2").get(`increase-rial/${amount}`);
		return this.getResource().get(`increase-rial/${amount}`);
	}

	/**
	 * redirect to bank
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public redirectBank(token: string) {
		window.location.href = `${this.baseURL}${this.prefix}/${this.entity}/${this.version}/web-redirect-to-bank/${token}`;
	}

	/**
	 * issue amount diff
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public issueDiffAmount(data: Wallet.IssueDiffAmount): Promise<HttpService.IssueDiffAmount> {
		return this.getResource().post("asset/issue/amount/diff", data);
	}

	/**
	 * wallet balance
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	// public walletBalance(): Promise<HttpService.WalletBalance> {
	// 	return this.getResource.post("balance");
	// }

	/**
	 * cancel shares
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public issueCancel(data: Wallet.SharesCancel): Promise<HttpService.BaseResponse> {
		return this.getResource().post("asset/cancel", data);
	}

	/**
	 * issue shares
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public sharesIssue(data: Wallet.SharesIssue): Promise<HttpService.BaseResponse> {
		return this.getResource().post("asset/issue", data);
	}

	/**
	 * withdraw wallet
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public withdrawWallet(data: Wallet.withdrawWallet): Promise<HttpService.BaseResponse> {
		return this.getResource().post("withdraw", data);
	}

	/**
	 * pay facilities
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	// TODO: should be refactored
	public payFacilities(id: number | string): Promise<HttpService.BaseResponse> {
		return this.getResource().post("", id);
	}
}

const WalletService = new WalletServiceProvider();

export default WalletService;
